import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import faLibrary, { fontAwesomeIcons } from '@/assets/icons/index'
import i18n from '@/i18n'
import '@/sass/overrides.sass'
import colors from '@/sass/variables.scss'

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.use(Vuetify)
// Font Awesome Vue docs: https://github.com/FortAwesome/vue-fontawesome
faLibrary.forEach((icon) => library.add(icon))

const iconConfig = Object.entries(fontAwesomeIcons).reduce((acc, [key, val]) => {
  return {
    [key]: {
      component: FontAwesomeIcon,
      props: {
        icon: [val.prefix, val.iconName],
      },
    },
    ...acc,
  }
}, {})

const theme = {
  primary: colors.primary,
  secondary: colors.secondary,
  success: colors.success,
  accent: colors.accent,
  muted: colors.muted,
  base: colors.base,
  error: colors.error,
}

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  icons: {
    iconfont: 'faSvg',
    values: iconConfig,
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
  breakpoint: {
    mobileBreakpoint: 960,
  },
})
